(() => {
  const copy = document.getElementById('mova-lite-popup-copy');
  if (!copy) return;
  const enhance = () => {
    const form = document.querySelector('form[data-uid="19e91794d2"]');
    const modal = form?.closest('.formkit-modal');
    const close = modal?.querySelector('[data-formkit-close]');
    if (!form || !modal || !close) return false;
    if (form.dataset.movaEnhanced) return true;
    form.dataset.movaEnhanced = 'true';
    const content = form.querySelector('[data-style="clean"]');
    const fragment = copy.content.cloneNode(true);
    content.prepend(fragment.querySelector('.mova-popup-intro'));
    content.append(fragment.querySelector('.mova-popup-note'));
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'mova-popup-title');
    modal.setAttribute('aria-describedby', 'mova-popup-description');
    close.setAttribute('aria-label', copy.dataset.close);
    const email = form.querySelector('input[name="email_address"]');
    email.type = 'email';
    email.autocomplete = 'email';
    email.placeholder = copy.dataset.email;
    email.setAttribute('aria-label', copy.dataset.email);
    const buttonText = form.querySelector('[data-element="submit"] > span');
    if (buttonText) buttonText.textContent = copy.dataset.button;
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close.click();
      }
      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll('input, button, a[href], [tabindex="0"]')]
        .filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
    return true;
  };
  if (enhance()) return;
  const observer = new MutationObserver(() => {
    if (enhance()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 120000);
})();
